import React, { useState } from 'react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { FileText, Download, Printer, FileSpreadsheet } from 'lucide-react';
export function Reports() {
  const [reportType, setReportType] = useState('daily');
  return <div className="space-y-6" data-id="element-176">
      <div data-id="element-177">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-178">রিপোর্ট</h1>
        <p className="text-slate-500" data-id="element-179">সিস্টেমের বিভিন্ন রিপোর্ট জেনারেট করুন</p>
      </div>

      {/* Report Generator Form */}
      <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm" data-id="element-180">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end" data-id="element-181">
          <div className="space-y-2" data-id="element-182">
            <label className="text-sm font-medium text-slate-700" data-id="element-183">
              রিপোর্টের ধরন
            </label>
            <select className="flex h-12 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-coral" value={reportType} onChange={e => setReportType(e.target.value)} data-id="element-184">
              <option value="daily" data-id="element-185">দৈনিক টিকিট বিক্রয়</option>
              <option value="monthly" data-id="element-186">মাসিক টিকিট বিক্রয়</option>
              <option value="gateway" data-id="element-187">গেটওয়ে ভিত্তিক আয়</option>
              <option value="failed" data-id="element-188">ব্যর্থ পেমেন্ট</option>
              <option value="printing" data-id="element-189">টিকিট প্রিন্টিং</option>
            </select>
          </div>
          <div className="space-y-2" data-id="element-190">
            <label className="text-sm font-medium text-slate-700" data-id="element-191">
              শুরুর তারিখ
            </label>
            <Input type="date" defaultValue="2026-05-19" data-id="element-192" />
          </div>
          <div className="space-y-2" data-id="element-193">
            <label className="text-sm font-medium text-slate-700" data-id="element-194">
              শেষ তারিখ
            </label>
            <Input type="date" defaultValue="2026-05-19" data-id="element-195" />
          </div>
          <Button className="h-12 w-full" data-id="element-196">রিপোর্ট তৈরি করুন</Button>
        </div>
      </div>

      {/* Generated Report Preview */}
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-197">
        {/* Report Actions */}
        <div className="p-4 border-b border-slate-100 flex justify-end gap-2 bg-slate-50" data-id="element-198">
          <Button variant="outline" size="sm" className="gap-2" data-id="element-199">
            <Download className="w-4 h-4" data-id="element-200" /> PDF
          </Button>
          <Button variant="outline" size="sm" className="gap-2" data-id="element-201">
            <FileSpreadsheet className="w-4 h-4" data-id="element-202" /> Excel
          </Button>
          <Button variant="outline" size="sm" className="gap-2" data-id="element-203">
            <Printer className="w-4 h-4" data-id="element-204" /> Print
          </Button>
        </div>

        {/* Report Content */}
        <div className="p-8" data-id="element-205">
          <div className="text-center mb-8 border-b-2 border-slate-200 pb-6" data-id="element-206">
            <h2 className="text-2xl font-bold text-slate-900 mb-1" data-id="element-207">
              চিম্বুক পাহাড় টিকিটিং সিস্টেম
            </h2>
            <p className="text-slate-600 mb-4" data-id="element-208">
              জেলা প্রশাসন, বান্দরবন পার্বত্য জেলা
            </p>
            <h3 className="text-xl font-bold text-slate-800" data-id="element-209">
              দৈনিক টিকিট বিক্রয় রিপোর্ট
            </h3>
            <p className="text-sm text-slate-500 mt-2" data-id="element-210">
              রিপোর্টের তারিখ: ১৯ মে ২০২৬
            </p>
          </div>

          {/* Summary Cards */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-211">
            <div className="p-4 bg-slate-50 rounded-xl border border-slate-100" data-id="element-212">
              <p className="text-sm text-slate-500 mb-1" data-id="element-213">মোট বিক্রিত টিকিট</p>
              <p className="text-2xl font-bold text-slate-900" data-id="element-214">৩৮৬</p>
            </div>
            <div className="p-4 bg-slate-50 rounded-xl border border-slate-100" data-id="element-215">
              <p className="text-sm text-slate-500 mb-1" data-id="element-216">মোট আয়</p>
              <p className="text-2xl font-bold text-brand-green" data-id="element-217">৳৭,৭২০</p>
            </div>
            <div className="p-4 bg-slate-50 rounded-xl border border-slate-100" data-id="element-218">
              <p className="text-sm text-slate-500 mb-1" data-id="element-219">bKash আয়</p>
              <p className="text-2xl font-bold text-[#e2136e]" data-id="element-220">৳৪,৪৮০</p>
            </div>
            <div className="p-4 bg-slate-50 rounded-xl border border-slate-100" data-id="element-221">
              <p className="text-sm text-slate-500 mb-1" data-id="element-222">Nagad আয়</p>
              <p className="text-2xl font-bold text-[#f7931e]" data-id="element-223">৳৩,২৪০</p>
            </div>
          </div>

          {/* Report Table */}
          <table className="w-full text-sm text-left border border-slate-200" data-id="element-224">
            <thead className="bg-slate-100" data-id="element-225">
              <tr data-id="element-226">
                <th className="px-4 py-3 font-bold border-b border-slate-200" data-id="element-227">
                  সময়
                </th>
                <th className="px-4 py-3 font-bold border-b border-slate-200" data-id="element-228">
                  টিকিট সংখ্যা
                </th>
                <th className="px-4 py-3 font-bold border-b border-slate-200" data-id="element-229">
                  গেটওয়ে
                </th>
                <th className="px-4 py-3 font-bold border-b border-slate-200 text-right" data-id="element-230">
                  পরিমাণ
                </th>
              </tr>
            </thead>
            <tbody data-id="element-231">
              <tr data-id="element-232">
                <td className="px-4 py-3 border-b border-slate-100" data-id="element-233">
                  ১০:০০ AM - ১১:০০ AM
                </td>
                <td className="px-4 py-3 border-b border-slate-100" data-id="element-234">৪৫</td>
                <td className="px-4 py-3 border-b border-slate-100" data-id="element-235">
                  bKash (২৫), Nagad (২০)
                </td>
                <td className="px-4 py-3 border-b border-slate-100 text-right" data-id="element-236">
                  ৳৯০০
                </td>
              </tr>
              <tr data-id="element-237">
                <td className="px-4 py-3 border-b border-slate-100" data-id="element-238">
                  ১১:০০ AM - ১২:০০ PM
                </td>
                <td className="px-4 py-3 border-b border-slate-100" data-id="element-239">৮২</td>
                <td className="px-4 py-3 border-b border-slate-100" data-id="element-240">
                  bKash (৫০), Nagad (৩২)
                </td>
                <td className="px-4 py-3 border-b border-slate-100 text-right" data-id="element-241">
                  ৳১,৬৪০
                </td>
              </tr>
              <tr data-id="element-242">
                <td className="px-4 py-3 border-b border-slate-100" data-id="element-243">
                  ১২:০০ PM - ০১:০০ PM
                </td>
                <td className="px-4 py-3 border-b border-slate-100" data-id="element-244">৬৫</td>
                <td className="px-4 py-3 border-b border-slate-100" data-id="element-245">
                  bKash (৩৫), Nagad (৩০)
                </td>
                <td className="px-4 py-3 border-b border-slate-100 text-right" data-id="element-246">
                  ৳১,৩০০
                </td>
              </tr>
            </tbody>
            <tfoot className="bg-slate-50 font-bold" data-id="element-247">
              <tr data-id="element-248">
                <td className="px-4 py-3 text-right" colSpan={3} data-id="element-249">
                  সর্বমোট:
                </td>
                <td className="px-4 py-3 text-right" data-id="element-250">৳৩,৮৪০</td>
              </tr>
            </tfoot>
          </table>

          <div className="mt-12 pt-8 border-t border-slate-200 flex justify-between text-sm text-slate-500" data-id="element-251">
            <p data-id="element-252">জেনারেট করেছেন: Md. Rahim Uddin</p>
            <p data-id="element-253">সময়: ১৯ মে ২০২৬, ০২:৪৫ PM</p>
          </div>
        </div>
      </div>
    </div>;
}